import type { SearchParams } from '@seek/chalice-types';
import omit from 'lodash/omit';
import sortBy from 'lodash/sortBy';
import toPairs from 'lodash/toPairs';
import { Md5 } from 'md5-typescript';

export const queryPart = (searchQueryHash: string = ''): string =>
  searchQueryHash.includes('-')
    ? searchQueryHash.split('-')[0]
    : searchQueryHash;

const formatDate = (date: any): string =>
  date instanceof Date ? date.getTime().toString().substring(6, 13) : '';

export const hashQuery = (query: SearchParams): string =>
  Md5.init(
    JSON.stringify(
      sortBy(toPairs(omit(query, ['page', 'sortmode'])), (item) => item[0]),
    ),
  );

export default ({
  date = new Date(),
  query,
  prevQueryId = '',
}: {
  date?: Date | any;
  query: SearchParams;
  prevQueryId?: string;
}): string => {
  const newQueryHash = hashQuery(query);

  return newQueryHash === queryPart(prevQueryId)
    ? prevQueryId
    : `${newQueryHash}-${formatDate(date)}`;
};
